import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("pc_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const localPhotos = () => {
  try {
    return JSON.parse(localStorage.getItem("pc_photos") || "{}");
  } catch {
    return {};
  }
};

export const uploadedMap = {};

export const photoSrc = (id) => {
  if (!id) return "";
  if (id.startsWith("local_"))
    return (
      localPhotos()[id] ||
      (uploadedMap[id] ? `${API}/photos/${uploadedMap[id]}` : "")
    );
  return `${API}/photos/${id}`;
};

export function saveLocalPhoto(dataUrl) {
  const id = `local_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
  const all = localPhotos();
  all[id] = dataUrl;
  try {
    localStorage.setItem("pc_photos", JSON.stringify(all));
  } catch {
    /* quota */
  }
  return id;
}

export async function downloadPdf(iid, token) {
  const url = token
    ? `/public/report/${iid}/pdf?t=${token}`
    : `/inspections/${iid}/pdf`;
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = `${iid}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}

export const reportLink = (iid, token) =>
  `${window.location.origin}/report/${iid}?t=${token}`;

export function whatsappLink(
  customer,
  iid,
  link,
  company = "PossessionCheck.com",
) {
  const brand = company || "PossessionCheck.com";
  const msg = `Hello ${customer.name},\n\nYour ${brand} Home Inspection Report is ready.\n\nReport ID: ${iid}\n\nYou can view/download your report here:\n${link}\n\nThank you,\n${brand}`;
  const phone = (customer.phone || "").replace(/\D/g, "");
  return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
}
